/**
 * Tool band, grouped tabs: the folded group's dropdown ("Output ▾").
 * Markup from block--header-image.html.twig (hero_tab_groups):
 *   <nav data-k-tool-tabs>
 *     <div data-k-tab-fold>
 *       <button data-k-tab-fold-btn aria-expanded aria-controls>
 *       <div role="menu" hidden> <a role="menuitem" tabindex="-1">…
 * Whether the dropdown or the inline group is shown is CSS (a container
 * query in hero.css); this only runs the menu: open/close, outside click,
 * Esc back to the button, arrow keys between items. Each item is a real
 * link, so a pick is an ordinary page load.
 */
(function (Drupal, once) {
  Drupal.behaviors.kToolTabsFold = {
    attach(context) {
      once("kToolTabsFold", "[data-k-tab-fold]", context).forEach((root) => {
        const btn = root.querySelector("[data-k-tab-fold-btn]");
        const menu = root.querySelector('[role="menu"]');
        if (!btn || !menu) return;
        const items = () => Array.from(menu.querySelectorAll('[role="menuitem"]:not([aria-disabled="true"])'));

        const onOutside = (event) => {
          if (!root.contains(event.target)) close(false);
        };
        const onKey = (event) => {
          if (event.key === "Escape") {
            event.preventDefault();
            close(true);
            return;
          }
          const list = items();
          if (!list.length) return;
          const i = list.indexOf(document.activeElement);
          if (event.key === "ArrowDown") {
            event.preventDefault();
            list[(i + 1) % list.length].focus();
          } else if (event.key === "ArrowUp") {
            event.preventDefault();
            list[(i - 1 + list.length) % list.length].focus();
          } else if (event.key === "Home") {
            event.preventDefault();
            list[0].focus();
          } else if (event.key === "End") {
            event.preventDefault();
            list[list.length - 1].focus();
          }
        };

        function open(focusFirst) {
          menu.hidden = false;
          btn.setAttribute("aria-expanded", "true");
          document.addEventListener("pointerdown", onOutside, true);
          root.addEventListener("keydown", onKey);
          if (focusFirst) {
            const list = items();
            (list.find((a) => a.getAttribute("aria-current") === "page") || list[0])?.focus();
          }
        }
        function close(refocus) {
          menu.hidden = true;
          btn.setAttribute("aria-expanded", "false");
          document.removeEventListener("pointerdown", onOutside, true);
          root.removeEventListener("keydown", onKey);
          if (refocus) btn.focus();
        }

        btn.addEventListener("click", () => {
          if (menu.hidden) open(false);
          else close(false);
        });
        btn.addEventListener("keydown", (event) => {
          if (event.key === "ArrowDown" || event.key === "ArrowUp") {
            event.preventDefault();
            if (menu.hidden) open(true);
            else items()[event.key === "ArrowDown" ? 0 : items().length - 1]?.focus();
          }
        });
        // Focus leaving the whole control (Tab out) closes it.
        root.addEventListener("focusout", (event) => {
          if (!menu.hidden && !root.contains(event.relatedTarget)) close(false);
        });
      });
    },
  };
})(Drupal, once);
